var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPalette = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM8 11.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM9 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.417 2.264A6.75 6.75 0 0 1 14.75 8.5a.75.75 0 0 1-.75.75h-1.3a5.748 5.748 0 0 1-5.7 5A5.75 5.75 0 0 1 1.25 8.5a6.75 6.75 0 0 1 4.167-6.236zM11.25 8.5a.75.75 0 0 1 .75-.75h1.196a5.255 5.255 0 0 0-3.187-4.1A5.25 5.25 0 0 0 2.75 8.5a4.25 4.25 0 1 0 8.5 0z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPalette);
export default ForwardRef;